import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseQueryWithCamelize } from "../apiTools";
import {
  ILoginParams,
  IResetPasswordParams,
  ILoginResponse,
  IForgotPasswordParams,
} from "./types";

const baseQuery = getBaseQueryWithCamelize(
  fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_AUTHENTICATION_API}authentication/`,
  })
);

export const ssoApi = createApi({
  reducerPath: "ssoApi",
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<ILoginResponse, ILoginParams>({
      query: (data) => ({
        url: "v1/login/",
        method: "POST",
        body: data,
      }),
    }),
    forgotPassword: builder.mutation<unknown, IForgotPasswordParams>({
      query: (data) => ({
        url: "v1/password-reset/",
        method: "POST",
        body: data,
      }),
    }),
    resetPassword: builder.mutation<unknown, IResetPasswordParams>({
      query: (data) => ({
        url: "v1/password-reset-confirm/",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useResetPasswordMutation,
  useLoginMutation,
  useForgotPasswordMutation,
} = ssoApi;
